export default "__VITE_ASSET__Mn2OsfdD__"